import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { useTheme as a } from "@mui/joy";
import r from "@mui/joy/Button";
import n from "@mui/joy/ButtonGroup";
import o from "@mui/joy/Input";
const i = { "& input[type=number]": { "-moz-appearance": "textfield", textAlign: "center" }, "& input[type=number]::-webkit-outer-spin-button": { "-webkit-appearance": "none", margin: 0 }, "& input[type=number]::-webkit-inner-spin-button": { "-webkit-appearance": "none", margin: 0 }, maxWidth: "64px", borderLeft: "none !important", backgroundColor: (e2) => e2.palette.isDarkMode ? e2.palette.neutral[200] : e2.palette.neutral[50], color: (e2) => e2.palette.isDarkMode ? e2.palette.neutral[600] : e2.palette.neutral[700] }, l = ({ name: l2, value: p, onChange: u, disabled: m, min: d, max: s, step: b = 1 }) => {
  const c = a(), k = (e2) => u({ target: { name: l2, value: e2 } }), h = (e2) => void 0 !== s && e2 >= s, g = (e2) => void 0 !== d && e2 <= d;
  return e(n, { size: "sm", "aria-label": " primary button group", disabled: m, children: [t(r, { onClick: () => (() => {
    const e2 = g(p) ? p : p - b;
    k(e2);
  })(), disabled: g(p), sx: { color: c.palette.isDarkMode ? c.palette.neutral[600] : "inherit", "&:hover": { background: c.palette.isDarkMode ? c.palette.neutral[250] : "inherit" } }, children: "-" }), t(o, { type: "number", value: p, onChange: (e2) => {
    const t2 = e2.target.value, a2 = "" === t2 ? 0 : parseFloat(t2);
    var r2;
    k((r2 = isNaN(a2) ? 0 : a2, h(r2) ? s : g(r2) ? d : r2));
  }, sx: i, disabled: m }), t(r, { onClick: () => (() => {
    const e2 = h(p) ? p : p + b;
    k(e2);
  })(), disabled: h(p), sx: { color: c.palette.isDarkMode ? c.palette.neutral[600] : "inherit", "&:hover": { background: c.palette.isDarkMode ? c.palette.neutral[250] : "inherit" } }, children: "+" })] });
};
export {
  l as QuantityPicker
};
//# sourceMappingURL=QuantityPicker.js.map
